module.exports = __webpack_public_path__ + "static/media/62.e5b3626f.jpg";